import './knowledge-base.component.ajscss';

import { AgentDesktopRouter } from '@agent/agent-interface/agent-desktop-router';
import { AgentDesktopState } from '@agent/agent-interface/agent-desktop-routing.module';
import { ChatKnowledgeService } from '@agent/agent-interface/contact-view/chat/services/chat-knowledge.service';
import { ISocialNetworkFrameService } from '@agent/agent-interface/contact-view/social-network/services/social-network-frame.service';
import { IEpticaDeprecatedService } from '@agent/core/channel-digit/mail/eptica/eptica-deprecated.service';
import { IEpticaFrame } from '@agent/core/channel-digit/mail/eptica/models/eptica.request.interfaces';
import { IContactDeprecatedService } from '@agent/core/contact/contact-deprecated.service';
import { AppExternalService } from '@commons/core/ui/app-external.service';
import { IEpticaExctractAttachment } from '@commons/history/history-mail/models/eptica-extract';
import { ng1Destroy } from '@commons/util/utilities/rx';
import { IComponentController, IComponentOptions, IHttpService, ILogService, isArray, ISCEService } from 'angular';
import { filter, Observable, take } from 'rxjs';

import { BookingStatus, BookingStmService, ChannelDirection, ChannelType, MediaType, ToasterFacade } from '@contact/upgrade';

import templateUrl from './knowledge-base.component.ajs.html';

const MODULE_NAME = 'knowledgeBase';
const GROUP_PATH: string = '/serviceKnowledgeBase/ajaxSubGroupList.action?requestLocale=fr_FR&documentGroupId=';
const DOCUMENT_PATH: string = '/serviceKnowledgeBase/ajaxDocument.action?requestLocale=fr_FR&documentId=';
const DOCUMENT_DOWNLOAD: string = '/api/template/attachment/';
const DOCUMENT_SEARCH: string = '/serviceKnowledgeBase/ajaxSearchDocumentPager.action?searchText=';

class KnowledgeBaseItem {
  constructor(
    public readonly itemId: string,
    public readonly label: string,
    public readonly version: number,
    public readonly numberOfSubGroups: number,
    public readonly numberOfDocuments: number,
    public readonly itemType: number,
    public readonly modificationDate: number,
    public readonly modificationStatus: number,
    public readonly matchValue: number,
    public readonly hasAttachment: boolean
  ) {}
}

class KnowledgeBaseDocument {
  constructor(
    public readonly documentId: string,
    public readonly documentGroupId: string,
    public readonly label: string,
    public readonly textContent: string,
    public readonly htmlContent: any,
    public readonly formattedCreationDate: string,
    public readonly formattedModifiedDate: string,
    public readonly attachments: IEpticaExctractAttachment[]
  ) {}
}

class KnowledgeBaseSearchRequest {
  constructor(
    public readonly total: number,
    public readonly page: number,
    public readonly records: number,
    public readonly rows: number,
    public readonly knowledgeBaseResults: KnowledgeBaseSearchResult[]
  ) {}
}

class KnowledgeBaseSearchResult {
  constructor(
    public readonly name: string,
    public readonly knowledgeBaseItemId: string,
    public readonly parentKnowledgeBaseItemId: string,
    public readonly matchValue: number,
    public readonly type: number,
    public readonly tooltipContent: string
  ) {}
}
class ContactKnowledgeBaseCtrl implements IComponentController {
  public searchValue: string = '';
  public canalName: string = 'none';
  public knowledgeBaseSearchRequest: KnowledgeBaseSearchRequest | undefined;
  public knowledgeBaseGroups: KnowledgeBaseItem[] = [];
  public knowledgeBaseDocuments: KnowledgeBaseItem[] = [];

  private epticaBaseUrl: string;
  private currentDocument: KnowledgeBaseDocument | undefined;
  private breadcrumb: KnowledgeBaseItem[] = [];
  private isContactSelected: boolean = false;
  private getTryNumber: number = 5;
  // Pagination
  private currentPage: number = 1;
  private pageSize: number = 10;
  public nbDisplayedPages: number = 3;

  close: Function;

  constructor(
    private readonly $http: IHttpService,
    private readonly $log: ILogService,
    private readonly $sce: ISCEService,
    private readonly epticaDeprecatedService: IEpticaDeprecatedService,
    private readonly contactDeprecatedService: IContactDeprecatedService,
    private readonly appExternalService: AppExternalService,
    private readonly toasterFacade: ToasterFacade,
    private readonly socialNetworkservice: ISocialNetworkFrameService,
    private readonly chatKnowledgeService: ChatKnowledgeService,
    private readonly router: AgentDesktopRouter,
    private bookingStmService: BookingStmService
  ) {}

  $onInit(): void {
    this.router.currentUrl$.pipe(ng1Destroy(this)).subscribe(url => {
      let selected = false;
      let canal = 'none';
      if (url?.indexOf(AgentDesktopState.BOOKING) !== -1) {
        selected = true;
        switch (true) {
          case url?.indexOf(MediaType.MAIL.toLowerCase()) !== -1: {
            canal = 'mail';
            break;
          }
          case url?.indexOf(MediaType.SOCIAL_NETWORK.toLowerCase()) !== -1: {
            canal = 'social_network';
            break;
          }
          case url?.indexOf(MediaType.CHAT.toLowerCase()) !== -1: {
            canal = 'chat';
            break;
          }
        }
      }
      this.isContactSelected = selected;
      this.canalName = canal;
    });

    this.epticaDeprecatedService.getBaseUrl().then(
      baseUrl => {
        this.epticaBaseUrl = baseUrl;
        this.openGroup();
      },
      error => {
        this.$log.error(`[knowledge base] Failed to load eptica baseUrl : ${error}`);
      }
    );

    this.bookingStmService.updated$
      .pipe(
        ng1Destroy(this),
        filter(({ status }) => status === BookingStatus.CLOSED)
      )
      .subscribe(() => {
        this.resetDocument();
        this.breadcrumb = [];
        this.openGroup();
        this.close();
      });
  }

  get buttonIsDisabled() {
    return !(this.isContactSelected && this.currentDocument != null);
  }

  insertDocument(): void {
    this.contactDeprecatedService.getSelectedContact().then(contact => {
      switch (contact.channel.type) {
        case ChannelType.SOCIAL_NETWORK:
          if (this.currentDocument) {
            this.socialNetworkservice.sendPostMessageToFrame(contact.responseId, this.currentDocument.htmlContent.toString());
          }
          break;
        case ChannelType.CHAT:
          if (this.currentDocument) {
            if (this.currentDocument.attachments && this.currentDocument.attachments.length > 0) {
              this.currentDocument.attachments.forEach(attachment => {
                this.$http.get(attachment.source).then(response => {
                  attachment.file = new File([new Blob([response.data as any], {})], attachment.filename);
                  this.chatKnowledgeService.setKnowledgeBaseMessage(contact.responseId, this.currentDocument!.textContent.toString(), [
                    attachment.file,
                  ]);
                });
              });
            } else {
              this.chatKnowledgeService.setKnowledgeBaseMessage(contact.responseId, this.currentDocument!.textContent.toString(), []);
            }
          }
          break;
        case ChannelType.MAIL:
        case ChannelType.UNITARY_MAIL:
          let request$: Observable<IEpticaFrame>;
          if (contact.channel.direction === ChannelDirection.INCOMING) {
            request$ = this.epticaDeprecatedService.loadRequest$({
              requestId: contact.epticaRequestId || 0,
            });
          } else {
            request$ = this.epticaDeprecatedService.loadOutgoingRequest$({
              idType: 'ias',
              customerId: contact.customerId || '',
              responseId: contact.responseId,
            });
          }
          request$.pipe(take(1)).subscribe(request => {
            this.appExternalService.getApplicationContainer(request.getFrameId()).forEach(frame => {
              // get eptica editor
              let oEditor = (frame.contentWindow as any).getHtmlEditor(frame.contentWindow);
              if (oEditor && !!this.currentDocument) {
                let content: string = this.currentDocument.htmlContent.toString() || this.currentDocument.textContent;
                // insert the text to the eptica frame
                oEditor.insertHtml(content);
                oEditor.focus();
              }

              if (!!this.currentDocument && !!this.currentDocument.attachments) {
                this.currentDocument.attachments.forEach(attachment => {
                  this.getFileObject(attachment.source, fileObject => {
                    fileObject.name = attachment.filename;
                    attachment.file = fileObject;
                    // upload file into Eptica's dropzone
                    if (!!attachment.file) {
                      request!.addUploadFiles([attachment.file]);
                    }
                  });
                });
              }
            });
          });
          break;
        default:
      }
    });
  }

  getFileBlob(url, cb) {
    let xhr = new XMLHttpRequest();
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.addEventListener('load', () => {
      cb(xhr.response);
    });
    xhr.send();
  }

  getFileObject(filePathOrUrl, cb) {
    this.getFileBlob(filePathOrUrl, blob => {
      cb(blob);
    });
  }

  search(searchValue: string): void {
    if (searchValue !== '') {
      this.$http.get(this.epticaBaseUrl + DOCUMENT_SEARCH + searchValue + '&rows=' + this.pageSize + '&page=' + this.currentPage).then(
        response => {
          let kbResponse: any = response.data;
          this.breadcrumb.splice(0);
          let results: KnowledgeBaseSearchResult[] = [];
          this.resetDocument();
          kbResponse.knowledgeBaseResults.forEach(kbItem => {
            results.push(
              new KnowledgeBaseSearchResult(
                kbItem.name,
                kbItem.knowledgeBaseItemId,
                kbItem.parentKnowledgeBaseItemId,
                kbItem.matchValue,
                kbItem.type,
                kbItem.tooltipContent
              )
            );
          });
          this.knowledgeBaseSearchRequest = new KnowledgeBaseSearchRequest(
            kbResponse.total,
            kbResponse.page,
            kbResponse.records,
            kbResponse.rows,
            results
          );
          if (results.length === 0) {
            this.toasterFacade.accessible({
              message: 'agent:panel.knowledge_base.no_result',
            });
          }
        },
        error => {
          this.$log.error(`[knowledge base] Failed to load eptica knowledge base search : ${error}`);
        }
      );
    }
  }

  openBreadcrumbGroup(group?: KnowledgeBaseItem): void {
    if (!!group) {
      this.breadcrumb.splice(this.breadcrumb.indexOf(group) + 1);
    } else {
      this.breadcrumb = [];
    }
    this.openGroup(group, false);
  }

  openGroup(group?: KnowledgeBaseItem, addToBreadcrumb = true): void {
    let groupId = group != null ? group.itemId : '';
    this.$http.get(this.epticaBaseUrl + GROUP_PATH + groupId).then(
      response => {
        if (group != null && addToBreadcrumb) {
          this.breadcrumb.push(group);
        }
        let kbResponse: any = response.data;
        this.knowledgeBaseGroups = [];
        this.knowledgeBaseDocuments = [];
        this.resetDocument();
        this.resetSearch();
        if (kbResponse != null && isArray(kbResponse)) {
          kbResponse.forEach(kbItem => {
            if (kbItem.itemType === 1) {
              this.knowledgeBaseDocuments.push(
                new KnowledgeBaseItem(
                  kbItem.itemId,
                  kbItem.label,
                  kbItem.version,
                  kbItem.numberOfSubGroups,
                  kbItem.numberOfDocuments,
                  kbItem.itemType,
                  kbItem.modificationDate,
                  kbItem.modificationStatus,
                  kbItem.matchValue,
                  kbItem.hasAttachment
                )
              );
            } else if (kbItem.itemType === 2) {
              this.knowledgeBaseGroups.push(
                new KnowledgeBaseItem(
                  kbItem.itemId,
                  kbItem.label,
                  kbItem.version,
                  kbItem.numberOfSubGroups,
                  kbItem.numberOfDocuments,
                  kbItem.itemType,
                  kbItem.modificationDate,
                  kbItem.modificationStatus,
                  kbItem.matchValue,
                  kbItem.hasAttachment
                )
              );
            }
          });
        } else if (this.getTryNumber > 0) {
          this.getTryNumber--;
          this.openGroup();
        }
      },
      error => {
        this.$log.error(`[knowledge base] Failed to load eptica knowledge base group : ${error}`);
      }
    );
  }

  openDocument(documentId: string): void {
    this.$http.get(this.epticaBaseUrl + DOCUMENT_PATH + documentId).then(
      response => {
        let kbResponse: any = response.data;
        if (!kbResponse) {
          return;
        }
        let doc = kbResponse;
        this.currentDocument = new KnowledgeBaseDocument(
          doc.documentId,
          doc.documentGroupId,
          doc.content.label,
          doc.content.textContent,
          this.$sce.trustAsHtml(doc.content.htmlContent),
          doc.creationDate,
          doc.modifiedDate,
          doc.content.attachments.map(attachment => ({
            id: attachment.documentAttachmentId,
            filename: attachment.contents[0].fileName,
            filesize: attachment.contents[0].filesize,
            description: attachment.contents[0].description,
            downloadUrl: this.epticaBaseUrl + DOCUMENT_DOWNLOAD + attachment.contents[0].documentAttachmentContentId,
            fileDetails: attachment.contents[0].label,
            title: attachment.contents[0].label + ' (' + attachment.contents[0].filesize.formatted + ')',
            source: this.epticaBaseUrl + DOCUMENT_DOWNLOAD + attachment.contents[0].documentAttachmentContentId,
          }))
        );
      },
      error => {
        this.$log.error(`[knowledge base] Failed to load eptica knowledge base document : ${error}`);
      }
    );
  }

  resetSearch(): void {
    this.knowledgeBaseSearchRequest = undefined;
    this.searchValue = '';
  }

  resetDocument(): void {
    this.currentDocument = undefined;
  }
}

export class ContactKnowledgeBase implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    close: '&',
  };
  controller = [
    '$http',
    '$log',
    '$sce',
    'epticaDeprecatedService',
    'contactDeprecatedService',
    'externalApplications',
    'toasterFacade',
    'socialNetworkFrameService',
    'chatKnowledgeService',
    'agentDesktopRouter',
    'bookingStmService',
    ContactKnowledgeBaseCtrl,
  ];
}

export default MODULE_NAME;
